import React from 'react';
import Table from '../../../../components/tables/Table';

const COLUMNS = [
  {
    label: 'Unit',
    field: 'unit',
    type: 'string',
    sortable: true,
  },
  {
    label: 'EVN',
    field: 'evn',
    type: 'string',
    sortable: true,
  },
  {
    label: 'Meter',
    field: 'meterID',
    type: 'string',
    sortable: true,
    render: (_row) => _row.meterID || '—',
  },
  {
    label: 'Status',
    field: 'status',
    type: 'string',
    sortable: true,
  },
  {
    label: 'Error Message',
    field: 'errorMessage',
    type: 'string',
    sortable: true,
    render: (_row) => _row.errorMessage || '—',
  },
  {
    label: 'File Name',
    field: 'fileName',
    type: 'string',
    sortable: true,
  },
  {
    label: 'Data Date',
    field: 'dataDate',
    type: 'date',
    sortable: true,
    render: (row) => {
      const v = row?.dataDate;
      if (!v) return '—';
      const d = new Date(v);
      if (Number.isNaN(d.getTime())) return '—';
      return d.toLocaleDateString('en-GB');
    },
  },
  {
    label: 'Date Loaded',
    field: 'rawDate',
    type: 'date',
    sortable: true,
    render: (row) => row?.dateLoaded || '—',
  },
  {
    label: 'Data Provider',
    field: 'dataProvider',
    type: 'string',
    sortable: true,
    render: (_row) => _row.dataProvider || '—',
  },
];

export default function IncomingFilesTable({ rows = [] }) {
  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={COLUMNS}
      stickyHeader
      zebra
      hover
      bordered
    />
  );
}
